import { render, staticRenderFns } from "./GoodsManage.vue?vue&type=template&id=cabdcee0&scoped=true&"
import script from "./GoodsManage.vue?vue&type=script&lang=js&"
export * from "./GoodsManage.vue?vue&type=script&lang=js&"
import style0 from "./GoodsManage.vue?vue&type=style&index=0&id=cabdcee0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabdcee0",
  null
  
)

export default component.exports